const DISCOUNT_CAUSES = [
  "system_error",
  "incorrect_account_setup",
  "delayed_onboarding",
  "cancelled_subscription",
  "payment_fee",
  "company_closed",
  "compensation",
];

const CANCELLATION_CAUSES = [
  "better_alternative",
  "bad_service",
  "merged_with_existing_customer",
  "change_in_physical_warehouse_setup",
  "company_closed",
  "low_volume",
  "never_started",
  "integration_missing",
  "pricing",
];

const CREDITING_CAUSES = [
  "system_error",
  "incorrect_account_setup",
  "delayed_onboarding",
  "cancelled_subscription",
  "payment_fee",
  "company_closed",
  "compensation",
];

const BILLING_SOURCES = ["webshipper", "third_party", "by_customer"];

export {
  DISCOUNT_CAUSES,
  CANCELLATION_CAUSES,
  CREDITING_CAUSES,
  BILLING_SOURCES,
};
